import React from "react";

//interfaces
import { IBasicTextInput } from "../../../interfaces/textInputs/IBasicTextInput";


/**
 * 
 *  Fairly Niche Text input, only sets the value when the input loses focus 
 *  Deeply rendering componets can cause on change events to refresh the dom
 *  too much, meaning elements lose focus and other weird behaviour
 *  adding this for thos situations
 *  
 */

const OnBlurTextInput = ({id, className, labelText, labelIsHidden, placeholderText, textString, setTextString, maxLength, isDisabled, isReadOnly}: IBasicTextInput) => {

    return (
        <div className={`basic-text-input-wrapper ${className ?? ""} `}>
            <label htmlFor="basic-text-input" className={`${labelIsHidden ? "sr-only" : ""} basic-text-input-label`}>
                {labelText}
            </label>
         
            <input
                key={id ? `basic-text-input-${id}`: ''}
                type="text"
                id={`basic-text-input-${id || ''}`}
                className={"basic-text-input"}
                placeholder={placeholderText}
                defaultValue={textString}
                onBlur={(e) => setTextString(e.target.value)}
                aria-label="Add your Text"
                maxLength={maxLength}
                disabled={isDisabled}
                readOnly={isReadOnly}
            />
        </div>
    );
};

export default OnBlurTextInput